/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { type FormProps } from 'redux-form';
import type { ContextRouter } from 'react-router';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';

import type { EditTutoringCompany_company } from './__generated__/EditTutoringCompany_company.graphql';
import enhancer from '../../enhancer';
import Well from '../../components/Well';
import { Grid } from '../../../components';

import TutoringCompanyForm from './components/TutoringCompanyForm';

import UpdateTutoringCompanyMutation from './mutations/UpdateTutoringCompanyMutation';

type Props = {
  company: EditTutoringCompany_company,
} & ContextRouter &
  FormProps;

type State = {
  loading: boolean,
  error: ?Error,
};

const styles = {
  toolbarButton: {
    margin: 5,
  },
};

class EditTutoringCompany extends Component<Props, State> {
  state = {
    loading: false,
    error: null,
  };

  componentDidMount() {
    const { initialize, company } = this.props;
    initialize(company);
  }

  handleRemove(studentId) {
    console.log('Remove Student', studentId);
  }

  handleAddStudent() {
    console.log('Add Student');
  }

  handleSave = async ({ students, studentCount, ...values }) => {
    try {
      await UpdateTutoringCompanyMutation({
        input: values,
      });
    } catch (error) {
      alert(error.message);
      this.setState({ error });
    }
  };

  // eslint-disable-next-line class-methods-use-this
  renderRow({ node }) {
    const { history } = this.props;
    return (
      <TableRow>
        <TableRowColumn>{node.fullname}</TableRowColumn>
        <TableRowColumn>
          <RaisedButton
            onClick={() => history.push(`/admin/student/${node.id}`)}
            label="View"
            secondary
          />
        </TableRowColumn>
        <TableRowColumn>
          <RaisedButton
            onClick={() => this.handleRemove(node.id)}
            label="Remove"
            secondary
          />
        </TableRowColumn>
      </TableRow>
    );
  }

  render() {
    const { submitting, company, invalid, handleSubmit } = this.props;

    const { error, loading } = this.state;

    const headers = ['Name', 'View'];

    return (
      <Well>
        <h3>Edit Tutoring Company</h3>
        <TutoringCompanyForm />
        <h3>Students</h3>
        {/* $FlowFixMe */}
        {company.students.edges && company.students.edges.length > 0 ? (
          <Grid
            headers={headers}
            renderRow={this.renderRow}
            rows={company.students.edges}
          />
        ) : (
          <h4>No Students Found</h4>
        )}
        {error && <div>{error.message}</div>}
        {(submitting || loading) && <LinearProgress mode="indeterminate" />}
        <div>
          <RaisedButton
            disabled={submitting || invalid}
            style={styles.toolbarButton}
            onClick={handleSubmit(this.handleSave)}
            label="Save"
            primary
          />
          <RaisedButton
            disabled={submitting}
            style={styles.toolbarButton}
            onClick={this.handleAddStudent}
            label="Add Student"
            secondary
          />
        </div>
      </Well>
    );
  }
}

const query = graphql`
  query EditTutoringCompanyAdminQuery($nodeId: ID!) {
    company: node(id: $nodeId) {
      ...EditTutoringCompany_company
    }
  }
`;

export default enhancer(EditTutoringCompany, {
  form: {
    form: 'editTutoringCompanyForm',
  },
  relay: {
    query,
    create: () =>
      createFragmentContainer(EditTutoringCompany, {
        company: graphql`
          fragment EditTutoringCompany_company on TutoringCompany {
            id
            name
            description
            referralCode
            internalMargin
            externalMargin
            studentCount
            students {
              edges {
                node {
                  id
                  fullname
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/modules/admin/company/EditTutoringCompany.js